import { Trans } from '@lingui/macro';
import classnames from 'classnames';
import React, { FC, memo } from 'react';
import { Link } from 'react-router-dom';

import { TextP3 } from 'uikit/Text';
import routes from 'utils/routeTranslator';

import { TL2Category$L4Group } from './CategoryGroups.helpers';
import './CategoryGroups.scss';

type L4LinkProps = {
  slug: string;
  name: string;
  city?: string;
  onClick: () => void;
};

const L4Link: FC<L4LinkProps> = (props) => {
  return (
    <Link
      to={routes.get('front::category', {
        slug: props.slug,
        city: props.city,
      })}
      onClick={props.onClick}
    >
      {props.name}
    </Link>
  );
};

type Props = {
  categories: TL2Category$L4Group[];
  linkToAllServices?: boolean;
  l2Id?: string;
  city?: string;
};

const CategoryGroups: FC<Props> = (props) => {
  const onCategoryClicked = () => {
    if (props.l2Id) {
      localStorage.setItem('wizardTouchPointButton', `rdr_kategorie_link_${props.l2Id}`);
    }
  };

  const city = props.city;

  const isSingle = props.categories.length <= 2; // If only 1 group or featured and default groups
  const groupsCN = classnames('categoryGroups__groups', {
    categoryGroups__groups_single: isSingle,
  });

  const listCN = classnames('categoryGroups__groupList', {
    categoryGroups__groupList_single: isSingle,
  });

  return (
    <div className="categoryGroups">
      <div className={groupsCN}>
        {isSingle ? (
          <ul className={classnames(listCN, 'categoryGroups__groupList_single')}>
            {props.categories.map((categoryGroup) =>
              categoryGroup.l4Categories.map((category) => (
                <li className="categoryGroups__groupItem" key={`categoryGroups__groupItem${category.slug}`}>
                  <L4Link name={category.name} slug={category.slug} city={city} onClick={onCategoryClicked} />
                </li>
              ))
            )}
          </ul>
        ) : (
          props.categories.map((categoryGroup) => (
            <div className="categoryGroups__group" key={`categoryGroups__groupItem${categoryGroup.name}`}>
              {categoryGroup.name !== 'default' && categoryGroup.name !== 'featured' && (
                <TextP3 bold className="categoryGroups__groupTitle">
                  {categoryGroup.name}
                </TextP3>
              )}
              <ul className={listCN}>
                {categoryGroup.l4Categories.map((category) => (
                  <li className="categoryGroups__groupItem" key={`categoryGroups__groupItem${category.slug}`}>
                    <L4Link name={category.name} slug={category.slug} city={city} onClick={onCategoryClicked} />
                  </li>
                ))}
              </ul>
            </div>
          ))
        )}
        {props.linkToAllServices && (
          <div className="categoryGroups__group" key={`categoryGroups__link_all`}>
            <ul className={listCN}>
              <li className="categoryGroups__groupItem">
                <Link to={routes.get('categories_seo', { city })} onClick={onCategoryClicked}>
                  <Trans>Lista wszystkich usług</Trans>
                </Link>
              </li>
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};
export default memo(CategoryGroups);
